import React, { useState, useEffect } from 'react'
import WelcomeImg from '../../assets/ai-readiness/welcome_img.webp'
import WelcomeImgMobile from '../../assets/ai-readiness/welcome_img_mobile.webp'
import styles from './initial-page.module.css'
import { useAiReadiness } from '../../context/AiReadinessContext.jsx'

export default function AiReadinessWelcomePage() {
    const [isMobile, setIsMobile] = useState(false)
    const { goToStep } = useAiReadiness()

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768)
        }

        handleResize()
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    const imageSrc = isMobile ? WelcomeImgMobile : WelcomeImg

    return (
        <div className={styles.mainContainer}>
            <div className={styles.imageSection}>
                <img
                    src={imageSrc}
                    className={styles.image}
                    alt="AI Readiness Welcome"
                />
            </div>
            <div className={styles.contentWrapper}>
                <div className={styles.topContent}>
                    <div className={styles.heading}>Check <span className={styles.highlight}>AI-Readiness</span> of Your School</div>
                    <div className={styles.description}>
                        Discover how future-ready your school really is — and what it takes to lead with AI.
                    </div>
                    <button className={styles.checkButton} onClick={() => { goToStep(1) }}>Check now</button>
                </div>
                <div className={styles.bottomContent}>
                    <div className={styles.subtitle}>
                        Take this quick, engaging check-up and get a personalised AI-Readiness Report designed exclusively for school leaders.
                    </div>
                </div>
            </div>
        </div>
    )
}
